<template>
  <path pid="0" d="M23.51 15.63a1 1 0 00-.93-.63h-6a1 1 0 100 2h3.48l-2.8 2.63A8 8 0 014 16.67a1 1 0 00-1.88.66 10 10 0 0016.5 3.74l2.93-2.76V22a1 1 0 002 0v-6a.92.92 0 00-.07-.36zM8.58 10a1 1 0 00-1-1H4.11l2.8-2.63a8 8 0 0113.22 3 1 1 0 001.28.61A1 1 0 0022 8.67 10 10 0 005.51 4.93L2.58 7.69V4a1 1 0 00-2 0v6a.92.92 0 00.07.36 1 1 0 00.93.63h6a1 1 0 001-.99z"/>
</template>
